module.exports = __webpack_public_path__ + "static/media/HONGORELL_MENU-normal.ddf43514.png";